<script setup lang="ts">
import Navigation from './components/Navigation.vue'
import Footer from './components/Footer.vue'
</script>

<template>
  <div class="min-h-screen bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950">
    <!-- Animated background pattern -->
    <div class="fixed inset-0 grid-pattern opacity-30 pointer-events-none"></div>
    
    <!-- Gradient overlay -->
    <div class="fixed inset-0 bg-gradient-to-br from-primary-900/10 via-transparent to-secondary-900/10 pointer-events-none"></div>
    
    <Navigation />
    
    <main class="relative z-10">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    
    <Footer />
  </div>
</template>

<style>
/* Global transition improvements */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>